<template>
  <div class="chat-widget">
    <div
      class="chat-button"
      @click="onToggleChat"
      :class="{ 'has-unread': unreadCount > 0 }"
    >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" fill="currentColor"/>
      </svg>
      <span v-if="unreadCount > 0" class="chat-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </div>

    <transition name="slide-up">
      <chat-window v-if="isChatOpen" @close="closeChat" />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ChatWindow from './ChatWindow.vue'

export default {
  name: 'ChatWidget',
  components: { ChatWindow },

  computed: {
    ...mapGetters('chatPlugin', ['unreadCount', 'isChatOpen', 'isConnected']),
    authUser () {
      return this.$store.state.auth && this.$store.state.auth.user
    },
    userId () {
      return this.authUser && this.authUser.id ? String(this.authUser.id) : null
    }
  },

  methods: {
    ...mapActions('chatPlugin', ['toggleChat', 'closeChat', 'loadRooms']),

    async ensureSocketConnected () {
      if (!this.userId) return
      if (!this.$chat || !this.$chat.socket) return

      // evita conectar duas vezes
      // (ajusta conforme a tua lib: pode ser this.$chat.isConnected, this.$chat.socket.connected etc)
      if (this.$chat.socket.connected) return

      await this.$store.dispatch('chatPlugin/requestNotificationPermission')

      // se teu connect aceita userId:
      this.$chat.socket.connect(this.userId)
    },

    async ensureRoomsLoaded () {
      // se teu loadRooms já tem cache, beleza; se não tiver, recomendo colocar cache no Vuex
      await this.loadRooms()
    },

    async onToggleChat () {
      // garante que tem sala antes de abrir (evita currentRoom undefined por corrida)
      await this.ensureRoomsLoaded()
      await this.ensureSocketConnected()
      this.toggleChat()
    }
  },

  watch: {
    // quando auth.user chegar depois do mounted, conecta e carrega
    userId: {
      immediate: true,
      async handler (val) {
        if (!val) return
        await this.ensureSocketConnected()
        await this.ensureRoomsLoaded()
      }
    }
  }
}
</script>

<style scoped>
.chat-widget { position: fixed; bottom: 20px; right: 20px; z-index: 9999; }
.chat-button { width: 60px; height: 60px; border-radius: 50%; background: linear-gradient(135deg, #9c27b0 0%, #673ab7 100%); color: white; display: flex; align-items: center; justify-content: center; cursor: pointer; box-shadow: 0 4px 12px rgba(156, 39, 176, 0.4); transition: all 0.3s ease; position: relative; }
.chat-button:hover { transform: scale(1.1); box-shadow: 0 6px 20px rgba(156, 39, 176, 0.6); }
.chat-badge { position: absolute; top: -5px; right: -5px; background: #f44336; color: white; border-radius: 12px; padding: 2px 6px; font-size: 11px; font-weight: bold; min-width: 20px; text-align: center; }
.slide-up-enter-active, .slide-up-leave-active { transition: all 0.3s ease; }
.slide-up-enter, .slide-up-leave-to { transform: translateY(20px); opacity: 0; }
@media (max-width: 768px) {
  .chat-widget { bottom: 10px; right: 10px; }
  .chat-button { width: 50px; height: 50px; }
}
</style>



// WEBPACK FOOTER //
// ChatWidget.vue?193286ec